module.exports = __webpack_public_path__ + "static/media/docs.77727d34.png";